const faqAdvanced = document.querySelectorAll('.faq-advanced');

faqAdvanced.forEach(faq => {

    const faqAdvancedTabs = faq.querySelectorAll('.faq-advanced_items .item');

    faqAdvancedTabs.forEach(item => {
        item.addEventListener('click', () => {
            faqAdvancedTabs.forEach(otherItem => {
                if (otherItem !== item && otherItem.getAttribute('open') != null) {
                    otherItem.style.paddingBottom = `0px`;
                    otherItem.removeAttribute('open');
                }
            });

            const itemContent = item.querySelector('.item__content');
            if(item.getAttribute('open') != null){
                item.style.paddingBottom = `0px`;
                item.removeAttribute('open');
            }else{
                item.style.paddingBottom = `${itemContent.offsetHeight}px`
                item.setAttribute('open', '');
            }
        });
    });
  
})